"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiply = void 0;
const multiply = ({ leftValue, rightValue, }) => {
    // Return scalar
    if (typeof leftValue === 'number' && typeof rightValue === 'number') {
        const result = leftValue * rightValue;
        return { error: null, result };
    }
    // Return array which matches length of left value
    if (Array.isArray(leftValue) && typeof rightValue === 'number') {
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < leftValue.length; idx += 1) {
            const leftElement = leftValue[idx];
            if (typeof leftElement !== 'number') {
                return {
                    error: `Multiplication error: array inputs must contain numbers, received: [${leftValue}, ${rightValue}]`,
                };
            }
            result.push(leftElement * rightValue);
        }
        return {
            error: null,
            result,
        };
    }
    // Return array which matches length of right value
    if (typeof leftValue === 'number' && Array.isArray(rightValue)) {
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < rightValue.length; idx += 1) {
            const rightElement = rightValue[idx];
            if (typeof rightElement !== 'number') {
                return {
                    error: `Multiplication error: array inputs must contain numbers, received: [${leftValue}, ${rightValue}]`,
                };
            }
            result.push(leftValue * rightElement);
        }
        return {
            error: null,
            result,
        };
    }
    // Validate array lengths match
    if (Array.isArray(leftValue) && Array.isArray(rightValue)) {
        if (leftValue.length !== rightValue.length) {
            return {
                error: `Multiplication error: array inputs must have the same length`,
            };
        }
        const result = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let idx = 0; idx < leftValue.length; idx += 1) {
            const leftElement = leftValue[idx];
            const rightElement = rightValue[idx];
            if (typeof leftElement !== 'number' || typeof rightElement !== 'number') {
                return {
                    error: `Multiplication error: array inputs must contain numbers, received: [${leftValue}, ${rightValue}]`,
                };
            }
            result.push(leftElement * rightElement);
        }
        return {
            error: null,
            result,
        };
    }
    // Invalid input
    return {
        error: `Multiplication error: inputs must be numbers or array of numbers, received: [${leftValue}, ${rightValue}]`,
    };
};
exports.multiply = multiply;
//# sourceMappingURL=multiply.js.map